
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';

@Component({
  components: {},
})

export default class DeleteCustomRole extends Vue {
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return stores.roles.delete(Number(this.$route.params.id))
      .then(() => {
        this.$router.push({name: 'access.roles'});
      })
      .catch((reason) => {
        console.error('Could not delete', reason);
      });
  }
}
